<div
    class="calls-in-call-panel"
    [class.calls-in-call-panel--fullscreen]="isFullscreen"
    [style.width.px]="isFullscreen ? null : panelWidth"
    [style.height.px]="isFullscreen ? null : panelHeight"
    cdkDrag
    cdkDragBoundary="body"
    cdkDragHandle=".calls-in-call-header"
>
    <header class="calls-in-call-header">
        <button type="button" mat-icon-button class="header-btn" [attr.aria-label]="'Menu' | autoTranslate" [matMenuTriggerFor]="headerMenu">
            <mat-icon svgIcon="heroicons_outline:ellipsis-vertical"></mat-icon>
        </button>
        <mat-menu #headerMenu="matMenu">
            <button mat-menu-item (click)="onLeave()">
                <mat-icon svgIcon="heroicons_outline:phone-x-mark"></mat-icon>
                <span autoTranslate>Sair da chamada</span>
            </button>
        </mat-menu>
        <span class="header-title">{{ room?.name ?? ('Chamada' | autoTranslate) }}</span>
        <span class="header-dot"></span>
        <button
            *ngIf="isFullscreen"
            type="button"
            mat-icon-button
            class="header-btn"
            [class.header-btn--active]="chatOpen"
            [attr.aria-label]="'Abrir chat' | autoTranslate"
            [matTooltip]="'Chat' | autoTranslate"
            (click)="onOpenChat()"
        >
            <mat-icon svgIcon="heroicons_outline:chat-bubble-left-right"></mat-icon>
        </button>
        <button
            type="button"
            mat-icon-button
            class="header-btn"
            [attr.aria-label]="isFullscreen ? ('Sair da tela cheia' | autoTranslate) : ('Tela cheia' | autoTranslate)"
            (click)="toggleFullscreen()"
        >
            <mat-icon
                [svgIcon]="isFullscreen ? 'heroicons_outline:arrows-pointing-in' : 'heroicons_outline:arrows-pointing-out'"
            ></mat-icon>
        </button>
    </header>

    <div class="calls-in-call-participants" *ngIf="participants?.length">
        <span class="calls-in-call-participants-label" autoTranslate>Na chamada:</span>
        <div class="calls-in-call-participants-list">
            <div *ngFor="let p of participants" class="calls-in-call-participant" [matTooltip]="p.name">
                <span class="calls-in-call-participant-avatar">{{ p.initials }}</span>
                <span class="calls-in-call-participant-name">{{ p.name }}</span>
            </div>
        </div>
    </div>

    <div class="calls-in-call-body">
        <div *ngIf="connecting" class="livekit-status" autoTranslate>Conectando…</div>
        <div *ngIf="connectError" class="livekit-status livekit-status--error">{{ connectError }}</div>

        <ng-container *ngIf="!connecting && !connectError">
            <!-- Solo: só eu -->
            <div class="livekit-stage livekit-stage--solo" *ngIf="layoutMode === 'solo' && soloTile as tile">
                <ng-container *ngTemplateOutlet="tileTpl; context: { $implicit: tile, size: 'main' }"></ng-container>
            </div>

            <!-- Spotlight + PiP (2 pessoas) -->
            <div class="livekit-stage livekit-stage--spotlight" *ngIf="layoutMode === 'spotlight'">
                <div class="livekit-spotlight" *ngIf="spotlightTile as spot">
                    <ng-container *ngTemplateOutlet="tileTpl; context: { $implicit: spot, size: 'main' }"></ng-container>
                </div>
                <div class="livekit-pip" *ngIf="pipTile as pip">
                    <ng-container *ngTemplateOutlet="tileTpl; context: { $implicit: pip, size: 'pip' }"></ng-container>
                </div>
            </div>

            <!-- Grid 3+ — colunas explícitas por contagem (não auto-fit numa linha) -->
            <div class="livekit-stage livekit-stage--grid" *ngIf="layoutMode === 'grid'">
                <div
                    class="livekit-grid"
                    [attr.data-density]="gridDensity"
                    [style.--livekit-cols]="gridColumnCount"
                >
                    <div class="livekit-grid-cell" *ngFor="let tile of tiles; trackBy: trackByIdentity">
                        <ng-container *ngTemplateOutlet="tileTpl; context: { $implicit: tile, size: 'grid' }"></ng-container>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="livekit-controls" *ngIf="!connecting && !connectError">
            <button
                type="button"
                mat-mini-fab
                color="primary"
                (click)="toggleMic()"
                [matTooltip]="(micEnabled ? 'Silenciar microfone' : 'Ativar microfone') | autoTranslate"
            >
                <mat-icon>{{ micEnabled ? 'mic' : 'mic_off' }}</mat-icon>
            </button>
            <button
                type="button"
                mat-mini-fab
                color="primary"
                (click)="toggleCamera()"
                [matTooltip]="(cameraEnabled ? 'Desligar câmera' : 'Ligar câmera') | autoTranslate"
            >
                <mat-icon>{{ cameraEnabled ? 'videocam' : 'videocam_off' }}</mat-icon>
            </button>
            <button
                *ngIf="canSwitchCamera"
                type="button"
                mat-mini-fab
                color="primary"
                (click)="switchCamera()"
                [disabled]="switchingCamera"
                [matTooltip]="'Alterar câmera' | autoTranslate"
                [attr.aria-label]="'Alterar câmera' | autoTranslate"
            >
                <mat-icon>flip_camera_ios</mat-icon>
            </button>
            <button
                type="button"
                mat-mini-fab
                color="warn"
                (click)="onLeave()"
                [matTooltip]="'Sair da chamada' | autoTranslate"
            >
                <mat-icon>call_end</mat-icon>
            </button>
        </div>
    </div>
</div>

<ng-template #tileTpl let-tile let-size="size">
    <div
        class="livekit-tile"
        [class.livekit-tile--pip]="size === 'pip'"
        [class.livekit-tile--speaking]="tile.speaking"
        [class.livekit-tile--camera-off]="tile.cameraOff || !tile.videoTrack"
    >
        <video
            *ngIf="tile.videoTrack && !tile.cameraOff"
            class="livekit-media-el livekit-media-el--video"
            [livekitTrack]="tile.videoTrack"
            [livekitMuted]="tile.isLocal"
            autoplay
            playsinline
        ></video>

        <div class="livekit-avatar" *ngIf="tile.cameraOff || !tile.videoTrack">
            <span class="livekit-avatar-initials">{{ tile.initials }}</span>
        </div>

        <audio
            *ngIf="tile.audioTrack && !tile.isLocal"
            class="livekit-media-el livekit-media-el--audio"
            [livekitTrack]="tile.audioTrack"
            [livekitMuted]="false"
            autoplay
        ></audio>

        <div class="livekit-tile-footer">
            <span class="livekit-tile-name">{{ tile.isLocal ? ('Você' | autoTranslate) : tile.name }}</span>
            <span class="livekit-tile-badges">
                <mat-icon *ngIf="tile.micMuted" class="livekit-badge" [matTooltip]="'Microfone desligado' | autoTranslate">mic_off</mat-icon>
                <mat-icon *ngIf="tile.cameraOff || !tile.videoTrack" class="livekit-badge" [matTooltip]="'Câmera desligada' | autoTranslate"
                    >videocam_off</mat-icon
                >
            </span>
        </div>
    </div>
</ng-template>
